<template>
  <div class="content">
    <h4 class="main-text text-center title">空气负(氧)离子浓度</h4>
    <div class="main-text time text-center">{{ time }}</div>
    <div class="name text-center">{{ anionFirst.anionTypeName }}</div>
    <div class="max main-text text-center">(24小时最大值)</div>
    <div class="number main-text text-center">{{ anionFirst.maxValue }}</div>
    <div class="level main-text text-center">
      <span>{{ anionFirst.grade }}</span>
      <img src="@/assets/image/led/icon.png" />
    </div>
    <div class="main-text text-center">Ⅰ级标准：</div>
    <div class="main-text text-center">大于1200个/立方厘米</div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  components: {},
  data() {
    return {
      apiUrl: '/api-air-quality/tokens/anion-data/list', //api地址
      apiTime: '',
      anionFirst: {}, //离子数据 第一
      loading: '',
      time: ''
    }
  },
  mounted() {
    this.getTime()
    this.getData()
  },
  methods: {
    //获取离子数据
    getData() {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios
        .get(this.apiUrl + `?anionTime=${this.apiTime}`)
        .then(({ data }) => {
          // this.time = data.time
          let arr = data.data || []
          this.anionFirst = { ...arr[0] }
          this.loading.close()
        })
        .catch((e) => {
          this.loading.close()
          this.$message.error('获取数据错误。')
        })
    },
    //获取时间
    getTime() {
      var req = new XMLHttpRequest()
      req.open('GET', location, false)
      req.send(null)
      let dateTime = new Date(req.getResponseHeader('Date'))
      let year = dateTime.getFullYear()
      let month = String(dateTime.getMonth() + 1)
      let day = String(dateTime.getDate())
      let month2 = String(dateTime.getMonth() + 1).padStart(2, '0')
      let day2 = String(dateTime.getDate()).padStart(2, '0')
      this.apiTime = year + '-' + month2 + '-' + day2
      this.time = month + '月' + day + '日'
    }
  }
}
</script>

<style lang="scss" scoped>
// @media screen and (max-width: 415px) {
//   .content {
//     transform: scale(0.9);
//     transform-origin: top left;
//   }
// }
.content {
  width: 416px;
  height: 1040px;
  margin: 0 auto;
  background-image: url(~@/assets/image/led/bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  overflow: hidden;
  padding-top: 90px;
  // font-family: 'oto Sans SC', sans-serif;
  .title {
    font-size: 44px;
    font-weight: 1400;
    -webkit-text-stroke: 1px #fff;
    text-stroke: 1px #fff;
    // font-family: 'Noto Sans SC';
  }
  .time {
    font-size: 46px;
    margin: 20px 0 50px 0;
    font-weight: 1400;
    // -webkit-text-stroke: 3px #fff;
    // text-stroke: 3px #fff;
  }
  .name {
    width: 370px;
    height: 74px;
    background-image: url(~@/assets/image/led/name.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 0 auto 40px auto;
    color: rgba(0, 0, 0, 1);
    font-size: 36px;
    font-weight: 600;
    line-height: 74px;
    -webkit-text-stroke: 1px #fff;
    text-stroke: 1px #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .number {
    font-size: 110px;
    margin: 8px 0 18px 0;
    font-weight: 1200;
    -webkit-text-stroke: 3px #fff;
    text-stroke: 3px #fff;
  }
  .level {
    display: flex;
    justify-content: center;
    margin-bottom: 110px;
    align-items: center;
    span {
      font-size: 70px;
    }
    img {
      width: 57px;
      height: 57px;
      margin-left: 20px;
    }
  }
}
.main-text {
  color: rgba(31, 172, 107, 1);
  font-size: 38px;
  font-weight: 600;
  -webkit-text-stroke: 1.5px #fff;
  text-stroke: 1.5px #fff;
}
.text-center {
  text-align: center;
}
</style>
